import * as dto from 'client/dto';
import { UpdatableContextModel } from 'hooks/useUpdatableContext';
import { createContext } from 'react';

import { GeoshapeAugmentedVM } from 'models/GeonameModels';
import { ProximalCaseModelMap } from 'models/DiseaseModels';

// TODO: 5411d096: refactor to change startDate to date and do toString immediately before API calls
export interface AppStateModel {
  activeRoute: string;
  locationFullName: string;
  eventTitleFallback: string;
  isMapHidden: boolean;
  isSidebarCollapsed: boolean;
  appMetadata: dto.ApplicationMetadataModel;
  isProximalDetailsExpandedDELP: boolean;
  isProximalDetailsExpandedEDP: boolean;
  proximalData: ProximalCaseModelMap;
  proximalGeonameShapes: GeoshapeAugmentedVM<dto.ProximalCaseCountModel>[];
  startDate: string;
  isTimeframeDropdownExpanded: boolean;
  isCustomTimeframeDropdownExpanded: boolean;
  isPanelDropdownExpanded: boolean;
}

export const AppStateContext = createContext<UpdatableContextModel<AppStateModel>>(null);
